import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { BOGLE_MEDIUM, BOGLE_REGULAR } from '../../constants/constant';

const styles = {
	heading: {
		fontSize: 18,
		marginBottom: '16px',
		fontFamily: BOGLE_MEDIUM,
	},
	content: {
		fontSize: 16,
		marginBottom: '28px',
		fontFamily: BOGLE_REGULAR,
	},
};

const steps = [
	{
		disableBeacon: true,
		target: '#hierarchy-filter',
		content: (
			<Box>
				<Typography style={styles.heading}>
					Your business, how you see it
				</Typography>
				<Typography style={styles.content}>
					From the full company view to items, monitor any level of your
					business at Walmart, at a given time
				</Typography>
			</Box>
		),
	},
	{
		disableBeacon: true,
		target: '#comparison-time-period-dropdown_autocomplete',
		placement: 'right',
		content: (
			<Box>
				<Typography style={styles.heading}>More flexibility</Typography>
				<Typography style={styles.content}>
					Slice, dice, and compare data in a more flexible way.
				</Typography>
			</Box>
		),
	},
	{
		disableBeacon: true,
		target: '.ag-group-value',
		placement: 'right',
		content: (
			<Box>
				<Typography style={styles.heading}>More depth</Typography>
				<Typography style={styles.content}>
					The drill-down function in table allows for better investigation into
					a specific business segment.
				</Typography>
			</Box>
		),
	},
	{
		disableBeacon: true,
		target: '#custom-table-column',
		placement: 'left',
		content: (
			<Box>
				<Typography style={styles.heading}>More personalized</Typography>
				<Typography style={styles.content}>
					Tailor your interface to better match your needs by customizing
					metrics in the table.
				</Typography>
			</Box>
		),
	},
];

export default steps;
